import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Lock body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" onClick={e => {
    // Close when clicking the overlay background
    if (e.target === e.currentTarget) onClose();
  }} data-id="element-13">
      <div className="relative w-full max-w-3xl bg-dark border border-gold/20 rounded-sm shadow-2xl flex flex-col max-h-[85vh] animate-in zoom-in-95 duration-300" data-id="element-14">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gold/10 shrink-0" data-id="element-15">
          <h2 className="text-2xl font-serif font-bold text-gold-light" data-id="element-16">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 text-light/50 hover:text-gold transition-colors rounded-full hover:bg-gold/10" aria-label="Close modal" data-id="element-17">
            <X className="w-6 h-6" data-id="element-18" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="p-6 overflow-y-auto" data-id="element-19">{children}</div>
      </div>
    </div>;
}